export enum KybFieldName {
  IdentityDocument = 'identity_document',
  Ubos = 'ubos',
  Nationality = 'nationality',
}
